module.exports = __webpack_public_path__ + "img/equality.6c00cfe8.jpg";